import { ContentSurvey } from '../content-survey/content-survey.model';
import { Document } from '../document/document.model';
import { Habit } from '../habit/habit.model';
import { InoutScreen } from '../inout-screen/inout-screen.model';
import { Reflection } from '../my-library/full-screen-reflection/reflection.model';
import { Poll } from '../poll/poll.model';
import { Question } from '../question/question.model';
import { RoutineInfo } from '../routine-v2/routine-info.model';
import { Base } from '../shared/base'
import { TodoListModel } from '../to-do-list/todo-list.model';
import { OnboardingSteps } from './onboarding-steps.model';

export class DailySteps extends Base {
    init() {
        this._fields = ['step', 'contentSurveys', 'documents', 'inoutScreens', 'habits', 'onboardingSteps', 'polls', 'originalStep', 'questions', 'reflections', 'routineInfo', 'stepStatus', 'toDos']; // your fields

        this._nestedFields = {
            habits: Habit,
            contentSurveys: ContentSurvey,
            documents: Document,
            inoutScreens: InoutScreen,
            onboardingSteps: OnboardingSteps,
            questions: Question,
            polls: Poll,
            reflections: Reflection,
            routineInfo: RoutineInfo,
            toDos: TodoListModel
        };

        // this.habits = {} as Habit;
        // this.contentSurveys = {} as ContentSurvey;
        // this.documents = {} as Document
        // this.inoutScreens = {} as InoutScreen
        // this.onboardingSteps = []
        // this.questions = {} as Question
        // this.polls = []
        // this.reflections = {} as Reflection
        // this.routineInfo = {} as Routine

         this.habits = null;
        this.contentSurveys = null;
        this.documents = null
        this.inoutScreens = null
        this.onboardingSteps = []
        this.questions = null
        this.polls = []
        this.reflections = null
        this.routineInfo = null
        this.toDos =null
    }

    afterInit() {
    }

    public step: number;
    public originalStep: number;
    public stepStatus: string;
    public habits: Habit;
    public contentSurveys: ContentSurvey;
    public documents: Document;
    public inoutScreens: InoutScreen;
    public onboardingSteps: OnboardingSteps[];
    public questions: Question;
    public polls: Poll[];
    public reflections: Reflection;
    public routineInfo: RoutineInfo;
    public toDos: TodoListModel

    public update(key, id, diff) {
        if (!this.hasOwnProperty(key)) { return false }
        let element;
        if (this[key]?.length > 0) {
            element = this[key]?.find(el => el?.id == id)
            if (element) {
                return Object.assign(element, diff)
            }
        }
        else {
            element = this[key]?.id === id
            if (element) {
                return Object.assign(this[key], diff)
            }
        }
    }
}